import { type StateType } from '../../states';
import { type RuntimeState, type RuntimeBaseState } from '../../states/runtime';
import { type Licence } from '../../types/common';
import { type Selector } from '../../types/selectors';

const emptyObj = {};

export const selectRuntimeState: Selector<RuntimeState | undefined> = (state: StateType) => state.runtime;

export const selectRuntimeLicence: Selector<Licence | undefined> = (state: StateType) =>
  selectRuntimeState(state)?.licence;

export const selectRuntimeSiteLicence: Selector<Licence | undefined> = (state: StateType) =>
  selectRuntimeState(state)?.siteLicence;

export const selectRuntimeIsWebsocketConnected: Selector<boolean> = (state: StateType) =>
  selectRuntimeState(state)?.isWebsocketConnected ?? false;

export const selectRuntimeOverrideSettings: Selector<Partial<RuntimeBaseState>> = (state: StateType) =>
  selectRuntimeState(state)?.overrideSettings ?? emptyObj;

export const selectRuntimeIsCashoutEnabled: Selector<boolean> = (state: StateType) =>
  selectRuntimeState(state)?.isCashoutEnabled ?? false;

export const selectRuntimeIsStreamHighlightsEnabled: Selector<boolean> = (state: StateType) =>
  selectRuntimeState(state)?.isStreamHighlightsEnabled ?? false;

export const selectRuntimeIsWTVEnabled: Selector<boolean> = (state: StateType) =>
  selectRuntimeState(state)?.isWTVEnabled ?? false;

export const selectRuntimeIsMyMatchEnabled: Selector<boolean> = (state: StateType) =>
  selectRuntimeState(state)?.isMyMatchEnabled ?? false;

export const selectRuntimeIsMyMatchSoccerEnabled: Selector<boolean> = (state: StateType) =>
  selectRuntimeState(state)?.isMyMatchSoccerEnabled ?? false;

export const selectRuntimeIsMyMatchSoccerLiveEnabled: Selector<boolean> = (state: StateType) =>
  selectRuntimeState(state)?.isMyMatchSoccerLiveEnabled ?? false;

export const selectRuntimeIsMyMatchBasketballEnabled: Selector<boolean> = (state: StateType) =>
  selectRuntimeState(state)?.isMyMatchBasketballEnabled ?? false;
